import {observable, action} from 'mobx'
import {setStore, ValueObjToObj, searchs} from "../../../../utils/Utils";
import {json} from "../../../../utils/ajax";
import {runInAction} from "mobx/lib/mobx";
import moment from "moment/moment";

class answerStatisticsStore {
    @observable loading  //
    @observable totalClosedLoop   //闭环总数
    @observable averageClosedLoopPeriod //平均闭环周期
    @observable totalNumberOfTopics //主题总数
    @observable closedLoopRate //闭环率
    @observable searchField //搜索
    @observable carseries //车系
    @observable pleasedRate //好评率
    @observable questionTypeList  //问题类型列表
    @observable questionTypeName  //当前选择的问题类型


    constructor() {
        this.loading = false
        this.totalClosedLoop = ''
        this.averageClosedLoopPeriod = ''
        this.totalNumberOfTopics = ''
        this.closedLoopRate = ''
        this.pleasedRate = ''
        this.searchField = {
            rangePicker:[],
            carseriesCode: ''
        }
        this.carseries = []
        this.questionTypeList = []
        this.questionTypeName = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**页面初始化*/
    @action
    initPage = async () => {
        this.loading = true
        let seacrhFild = {
            carseriesCode: this.searchField.carseriesCode ? this.searchField.carseriesCode: '',
            startTime: this.searchField.rangePicker.length>0 ? moment(this.searchField.rangePicker[0]).format("YYYY-MM-DD") : '',
            endTime: this.searchField.rangePicker.length>0 ? moment(this.searchField.rangePicker[1]).format("YYYY-MM-DD") : ''
        }
        let res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerStatistics/AllAnswerStatisticsData:search`, searchs(seacrhFild))
        runInAction(() => {
            this.totalClosedLoop = res.totalClosedLoop
            this.averageClosedLoopPeriod = res.averageClosedLoopPeriod
            this.totalNumberOfTopics = res.totalNumberOfTopics
            this.closedLoopRate = res.closedLoopRate
            this.pleasedRate = res.pleasedRate
            this.loading = false
        })
    }

    /***搜索表单、列表新增绑值**/
    @action
    onFormField = (changedFields, fields) => {
        const change = ValueObjToObj(changedFields)
        this[fields] = {...this[fields], ...change}
    }

    /***问题类型**/
    @action
    getQuestionType = async () => {
        let res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/getOneRoot`, {name: '问题类型/'})
        runInAction(()=> {
            this.questionTypeList = Array.isArray(res.children) ? res.children : []
        })
    }

    /**请求车系**/
    @action
    carSeries = async (e) => {
        this.questionTypeName = e ? e : ''
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/moduleNameQueryCarSeriesTable/${e}`)
        runInAction(() => {
            this.carseries = Array.isArray(res) ? res : []
        })
    }

    /**主页面搜索重置**/
    @action
    handleReset = () => {
        this.searchField = {
            rangePicker:[],
            carseriesCode: ''
        }
        this.questionTypeName = ''
        this.initPage()
    }
}

export default new answerStatisticsStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/AnswerPlatform/AnswerStatistics/store.js